import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description }) => {
  const defaultTitle = 'Masse-terclass';
  const defaultDescription = "Masse-terclass est l'application de musculation ultime pour tracker vos entraînements, gagner de l'XP et monter en niveau, le tout avec vos amis !";

  const seoTitle = title ? `${defaultTitle} | ${title}` : defaultTitle;
  const seoDescription = description || defaultDescription;

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
    </Helmet>
  );
};

export default SEO;
